require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./context"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./context"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./context")) : factory(root["./utils"], root["./context"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__21__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[75],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(615);


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _withDragLayer = _interopRequireDefault(__webpack_require__(616));

exports.withDragLayer = _withDragLayer.default;
exports.default = _withDragLayer.default;

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = withDragLayer;
exports.DragLayer = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _reactDnd = __webpack_require__(23);

var _context = __webpack_require__(21);

var _utils = __webpack_require__(5);

var _dec, _class, _class2, _temp;

const {
  omit
} = _utils.lodash;
let DragLayer = (_dec = (0, _reactDnd.DragLayer)(monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging(),
  canDrop: () => monitor.isDragging() && monitor.getTargetIds().some(targetId => monitor.isOverTarget(targetId) && monitor.canDropOnTarget(targetId))
})), _dec(_class = (_temp = _class2 = class DragLayer extends _react.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.isDragging && !this.props.isDragging) {
      nextProps.onBeginDrag();
    } else if (!nextProps.isDragging && this.props.isDragging) {
      nextProps.onEndDrag();
    }
  }

  render() {
    const {
      currentOffset,
      item,
      isDragging,
      canDrop
    } = this.props;

    if (!currentOffset || !item || !isDragging || !item.dragLayerRenderer) {
      return null;
    }

    return item.dragLayerRenderer({
      itemProps: item,
      droppable: canDrop(),
      currentOffset
    });
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  item: _propTypes.default.object,
  isDragging: _propTypes.default.bool.isRequired,
  currentOffset: _propTypes.default.object,
  onBeginDrag: _propTypes.default.func.isRequired,
  onEndDrag: _propTypes.default.func.isRequired,
  canDrop: _propTypes.default.func.isRequired
}), _temp)) || _class);
exports.DragLayer = DragLayer;

function withDragLayer(WrappedComponent) {
  var _dec2, _class3, _class4, _temp2;

  let WithDragLayer = (_dec2 = (0, _context.withContext)('theme'), _dec2(_class3 = (_temp2 = _class4 = class WithDragLayer extends _react.Component {
    constructor(...args) {
      super(...args);
      (0, _defineProperty2.default)(this, "_onBeginDrag", () => {
        this._dragLayerContainer.hidden = false;
      });
      (0, _defineProperty2.default)(this, "_onEndDrag", () => {
        this._dragLayerContainer.hidden = true;
      });
    }

    componentWillMount() {
      const dragLayerContainer = document.createElement('div');
      dragLayerContainer.hidden = true;
      document.body.appendChild(dragLayerContainer);
      this._dragLayerContainer = dragLayerContainer;
    }

    componentWillUnmount() {
      if (this._dragLayerContainer) {
        _reactDom.default.unmountComponentAtNode(this._dragLayerContainer);

        this._dragLayerContainer.parentNode.removeChild(this._dragLayerContainer);

        this._dragLayerContainer = null;
      }
    }

    render() {
      const {
        dragLayerForwardRef,
        ...other
      } = this.props;
      const passThroughProps = omit(other, 'theme');
      return [/*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
        key: "0"
      }, passThroughProps, {
        ref: dragLayerForwardRef
      })), _reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(DragLayer, {
        onBeginDrag: this._onBeginDrag,
        onEndDrag: this._onEndDrag
      }), this._dragLayerContainer)];
    }

  }, (0, _defineProperty2.default)(_class4, "propTypes", {
    theme: _propTypes.default.string,
    dragLayerForwardRef: _propTypes.default.any
  }), _temp2)) || _class3);
  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(WithDragLayer, (0, _extends2.default)({}, props, {
    dragLayerForwardRef: ref
  })));
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ })

},[[614,0]]]);
});